<div class="main-content table-page table-page--compact incidencias-board-page" [class]="vista.clasePagina">
  <div class="container-fluid">
    <section class="table-page__card">
      <div class="incidencias-board-page__toolbar-anchor">
        <div class="table-page__toolbar table-page__toolbar--filters">
          <div class="table-page__filters-grid incidencias-board-page__filters-grid">
            <div class="table-page__filter table-page__filter--wide">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Área</mat-label>
                <mat-select
                  [(ngModel)]="areaSeleccionada"
                  [ngModelOptions]="{ standalone: true }"
                  (selectionChange)="onAreaChange($event.value)">
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="formArea"
                      [placeholderLabel]="'Área'"
                      [noEntriesFoundLabel]="'No se encontró información'">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let area of filterArea | async; trackBy: trackByAreaId" [value]="area">
                    {{ area.area }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="incidencias-board-page__toolbar-actions">
            <label class="table-page__page-size incidencias-board-page__page-size">
              <span>Registros</span>
              <select [ngModel]="itemsPerPage" (ngModelChange)="onItemsPerPageChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">
                  {{ option }}
                </option>
              </select>
            </label>

            <button
              type="button"
              mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
              [class.table-page__icon-btn--secondary]="vista.accionSecundaria"
              (click)="accionPrincipal()">
              <i class="material-icons">{{ vista.iconoAccion }}</i>
              <span>{{ vista.textoAccion }}</span>
            </button>

            <button
              type="button"
              mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
              (click)="actualizaTickets()">
              <i class="material-icons">refresh</i>
              <span>Actualizar</span>
            </button>

            <button
              type="button"
              mat-raised-button
              class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
              #filtersButton
              (click)="activafiltros($event)">
              <i class="material-icons">tune</i>
              <span>Filtros</span>
              <strong class="incidencias-board-page__toolbar-badge" *ngIf="getActiveFiltersCount() > 0">
                {{ getActiveFiltersCount() }}
              </strong>
            </button>

            <div class="incidencias-board-page__toolbar-summary">
              <span>Total</span>
              <strong>{{ boardTotalItems }}</strong>
            </div>
          </div>
        </div>

        <div
          class="incidencias-board-page__filters-popover"
          #filtersPopover
          *ngIf="filtersPopupOpen"
          [class.is-open]="filtersPopupOpen">
          <div class="incidencias-board-page__filters-dialog">
            <div class="incidencias-board-page__filters-dialog-header">
              <div>
                <h3>Filtros de tickets</h3>
                <p>Aplica búsqueda por asunto, fecha de solicitud o número de ticket.</p>
              </div>
            </div>

            <div class="incidencias-board-page__filters-panel">
              <form [formGroup]="options">
                <div class="table-page__filters-grid incidencias-board-page__filters-grid" [class]="vista.clasePagina + '__filters-grid--advanced'">
                  <div class="table-page__filter table-page__filter--wide">
                    <mat-form-field appearance="outline" class="table-page__field">
                      <mat-label>Asunto</mat-label>
                      <input
                        matInput
                        aria-label="Asunto"
                        formControlName="asuntoCtrl"
                        maxlength="120"
                        (keyup.enter)="aplicarFiltros()" />
                    </mat-form-field>
                  </div>

                  <div class="table-page__filter table-page__filter--medium">
                    <mat-form-field appearance="outline" class="table-page__field">
                      <mat-label>Fecha</mat-label>
                      <input matInput aria-label="Fecha" [matDatepicker]="pickerSolicitud" formControlName="dateCtrl" readonly />
                      <mat-datepicker-toggle matSuffix [for]="pickerSolicitud"></mat-datepicker-toggle>
                      <mat-datepicker #pickerSolicitud></mat-datepicker>
                    </mat-form-field>
                  </div>

                  <div class="table-page__filter table-page__filter--medium">
                    <mat-form-field appearance="outline" class="table-page__field">
                      <mat-label>No. ticket</mat-label>
                      <input
                        matInput
                        aria-label="No. ticket"
                        type="number"
                        min="1"
                        formControlName="numeroCtrl"
                        (keyup.enter)="aplicarFiltros()" />
                    </mat-form-field>
                  </div>
                </div>
              </form>
            </div>

            <div class="incidencias-board-page__filters-dialog-actions">
              <button
                type="button"
                mat-raised-button
                class="btn table-page__icon-btn table-page__icon-btn--secondary incidencias-board-page__toolbar-btn"
                (click)="limpiaFiltrosPopup()">
                <i class="material-icons">filter_alt_off</i>
                <span>Limpiar</span>
              </button>
              <button
                type="button"
                mat-raised-button
                class="btn table-page__icon-btn incidencias-board-page__toolbar-btn"
                (click)="aplicarFiltros()">
                <i class="material-icons">done</i>
                <span>Aplicar</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="areaSeleccionada; else emptySelectionTpl">
        <div class="incidencias-board-page__board-shell">
          <div class="incidencias-board-page__drag-hint">
            <mat-icon>pan_tool_alt</mat-icon>
            <span>Arrastra para ver más columnas</span>
          </div>

          <div
            class="incidencias-board-page__board"
            [class.is-dragging]="isDraggingBoard"
            #boardScroller
            (mousedown)="startBoardDrag($event)"
            (mousemove)="moveBoardDrag($event)"
            (mouseup)="stopBoardDrag()"
            (mouseleave)="stopBoardDrag()">
            <article
              class="incidencias-board-page__column"
              *ngFor="let column of columnasKanban; let index = index; trackBy: trackByColumn"
              [style.--incidencia-column-color]="column.color">
              <header
                class="incidencias-board-page__column-header"
                [class]="vista.clasePagina + '__column-header'"
                [style.backgroundColor]="column.color">
                <div class="incidencias-board-page__column-title" [class]="vista.clasePagina + '__column-title'">
                  <span class="material-icons">{{ column.icon }}</span>
                  <div class="incidencias-board-page__column-title-text">
                    <strong>{{ column.titulo }}</strong>
                    <small>{{ getColumnTotalItems(index) }}</small>
                  </div>
                </div>

                <button
                  type="button"
                  mat-icon-button
                  [class]="vista.clasePagina + '__refresh-btn'"
                  *ngIf="hasPendingRefresh(column.estatus)"
                  (click)="recargarColumna(column, index)"
                  matTooltip="Actualizar columna">
                  <mat-icon>refresh</mat-icon>
                </button>
              </header>

              <div
                class="incidencias-board-page__column-pager"
                *ngIf="getColumnTotalItems(index) > 0">
                <div class="table-page__pager incidencias-board-page__pager">
                  <span [class]="vista.clasePagina + '__pager-summary'">
                    {{ getColumnConfig(index)?.currentPage || 1 }}/{{ getTotalPages(getColumnConfig(index)) || 1 }}
                  </span>
                  <button
                    type="button"
                    class="table-page__pager-link"
                    (click)="firstPage(index)"
                    [disabled]="(getColumnConfig(index)?.currentPage || 1) <= 1"
                    aria-label="Primera página"
                    title="Primera página">
                    «
                  </button>
                  <button
                    type="button"
                    class="table-page__pager-link"
                    (click)="previousPage(index)"
                    [disabled]="(getColumnConfig(index)?.currentPage || 1) <= 1"
                    aria-label="Página anterior"
                    title="Página anterior">
                    ‹
                  </button>

                  <ng-container *ngFor="let page of getPaginationItems(getColumnConfig(index))">
                    <button
                      *ngIf="isPageNumber(page); else ellipsisTpl"
                      type="button"
                      class="table-page__pager-page"
                      [class.is-current]="page === (getColumnConfig(index)?.currentPage || 1)"
                      (click)="pageChanged(page, index)">
                      {{ page }}
                    </button>
                  </ng-container>

                  <ng-template #ellipsisTpl>
                    <span class="table-page__pager-ellipsis">...</span>
                  </ng-template>

                  <button
                    type="button"
                    class="table-page__pager-link"
                    (click)="nextPage(index)"
                    [disabled]="(getColumnConfig(index)?.currentPage || 1) >= getTotalPages(getColumnConfig(index))"
                    aria-label="Página siguiente"
                    title="Página siguiente">
                    ›
                  </button>
                  <button
                    type="button"
                    class="table-page__pager-link"
                    (click)="lastPage(index)"
                    [disabled]="(getColumnConfig(index)?.currentPage || 1) >= getTotalPages(getColumnConfig(index))"
                    aria-label="Última página"
                    title="Última página">
                    »
                  </button>
                </div>
              </div>

              <div class="incidencias-board-page__column-body">
                @if (vista.columnasCliente) {
                  <app-notificacion-cte-ticket
                    [estatusSolicitud]="column.estatus"
                    [nombreCorto]="nombreCorto"
                    [numero]="numero"
                    [fechaSeleccionada]="fechaSeleccionada"
                    [areaSeleccionada]="areaSeleccionada"
                    [columnTitle]="column.titulo"
                    [columnColor]="column.color"
                    (numPaginasEvent)="setLegacyPaginacionState($event)"
                    (paginationStateChange)="setPaginacionState($event)">
                  </app-notificacion-cte-ticket>
                } @else {
                  <app-notificacion-ticket
                    [estatusSolicitud]="column.estatus"
                    [nombreCorto]="nombreCorto"
                    [numero]="numero"
                    [fechaSeleccionada]="fechaSeleccionada"
                    [areaSeleccionada]="areaSeleccionada"
                    [ticket]="ticket"
                    [columnTitle]="column.titulo"
                    [columnColor]="column.color"
                    (numPaginasEvent)="setLegacyPaginacionState($event)"
                    (paginationStateChange)="setPaginacionState($event)">
                  </app-notificacion-ticket>
                }
              </div>
            </article>
          </div>
        </div>
      </ng-container>

      <ng-template #emptySelectionTpl>
        <div class="table-page__empty-state incidencias-board-page__empty-selection">
          <mat-icon>dashboard_customize</mat-icon>
          <p>{{ vista.textoSinAreas }}</p>
        </div>
      </ng-template>
    </section>
  </div>
</div>
